import Hashids from "hashids";

// perusahaan detail = 1
// lowongan detail = 2

const hashids = new Hashids("test", 8);

export default hashids;
